<template>
    <section class="m-share-in-socials">
        <div class="m-share-in-socials__content">
            <div class="socials-content">
                <div class="socials-content__title">
                    {{ $t('blog.share_in_socials') }}
                </div>
                <div class="socials-content__socials">
                    <y-socials
                        size="normal"
                        svg-size="32px"
                        :share="share"
                        color="colored"
                        svg
                        rounded
                    />
                </div>
            </div>
        </div>

        <div
            v-if="tags.length"
            class="m-share-in-socials__tags"
        >
            <span class="tags-title">{{ $t('blog.tags') }}</span>
            <div class="tags-link">
                <router-link
                    v-for="(tag, i) in tags"
                    :key="i"
                    class="tag-link"
                    :to="''"
                >
                    {{ tag.title }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script >

    import { YSocials } from '@groot-components/all';

    export default {
        name      : 'BlogShareInSocials',
        components: { YSocials },

        /**
         *
         * @inheritDoc
         */
        props: {
            title: {
                type: String,
            },
            tags: {
                type: Array,
            },
        },

        computed: {
            /**
             * Return Share data
             *
             * @returns {object}
             */
            share() {
                return {
                    url  : window.location.href,
                    title: this.title,
                };
            },

        },
    };

</script>

<style lang="scss" src="./share-in-socials.scss"/>
